// All generic app wide constants
// and constants used in helper functions can go here

// Date formatting
export const DATE_FORMAT_MONTHS_LIST_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DATE_FORMAT_MONTHS_LIST_ES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

/* In case of PLCC clients, the client id is "paysol",
/* use "portfolio" property as real client id
*/
export const CLIENT_ID_PAYSOL = 'paysol';

// Feature Names to switch
export const FEATURES_TO_DISPLAY = {
  SINGLE_USE_CARD: 'FEATURE_SINGLE_USE_CARD',
  VIRTUAL_CARD: 'FEATURE_VIRTUAL_CARD',
  CREDIT_LIMIT_INCREASE: 'CREDIT_LIMIT_INCREASE',
  SHOPPING_BARCODE: 'FEATURE_SHOPPING_BARCODE',
};

export const PAYMENT_TOKEN_TYPES = {
  SINGLE_USE: 'singleUse',
  SHOPPING_BARCODE: 'tokenizedShoppingPass',
};
